import { render, staticRenderFns } from "./comments-list-more-replies.vue?vue&type=template&id=6b997eee"
import script from "./comments-list-more-replies.vue?vue&type=script&lang=ts"
export * from "./comments-list-more-replies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports